import { Link } from "react-router-dom";
import "./BottomBar.scss";
import { useLocation } from "react-router-dom";
import { dashboardIcon, MoreIcon } from "../../assets/assets";

const BottomBar = () => {
  let location = useLocation();
  console.log(location.pathname);

  return (
    <section>
      <div className="bottom-bar">
        <div className="container-fluid">
          <div className="row">
            <div className="col-4">
              <Link to={"/app/dashboard"}>
                <div className="text-center">
                  <img className="" src={dashboardIcon} alt="" />
                  <div>Dashboard </div>
                </div>
              </Link>
            </div>
            <div className="col-4">
              <Link
                to={
                  location.pathname == "/app/sub-partner"
                    ? "/app/new-sub-partner"
                    : "/app/new-business"
                }
              >
                
                <span className="plus"> + </span>
                <div className="pt-4 ms-2"></div>
              </Link>
            </div>
            <div className="col-4">
              <Link to={"/app/more-details"}>
                <div>
                  <img className="ms-2" src={MoreIcon} alt="" />
                </div>
                <span className="">More </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomBar;
